import { Link } from '@tanstack/react-router';
import { ArrowLeft } from 'lucide-react';

import { NessoLogo } from '@nesso/ui/icons/nesso-logo';
import { Button } from '@nesso/ui/primitives/button';

export function CalendarPageHeading() {
    return (
        <div className="flex items-center gap-2">
            <Button asChild variant="ghost" size="icon" aria-label="Back to dashboard">
                <Link to="/dashboard">
                    <ArrowLeft className="size-5" />
                </Link>
            </Button>
            <NessoLogo />
            <h1 className="text-base text-muted-foreground">Calendar</h1>
        </div>
    );
}
